export default __webpack_public_path__ + "static/media/Spot icon.3f159d99.png";